export default __webpack_public_path__ + "static/media/thank_you_hero.d0121758.png";